import { z } from 'zod';

// User roles
export const userRoleSchema = z.enum(['user', 'admin']);
export type UserRole = z.infer<typeof userRoleSchema>;

export const userSchema = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  name: z.string().min(1).max(100),
  avatarUrl: z.string().url().nullable().optional(),
  role: userRoleSchema.default('user'),
  storageUsed: z.number().int().min(0),
  storageLimit: z.number().int().min(0),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type User = z.infer<typeof userSchema>;

export const userPublicSchema = userSchema.omit({
  createdAt: true,
  updatedAt: true,
});

export type UserPublic = z.infer<typeof userPublicSchema>;

export const loginRequestSchema = z.object({
  email: z.string().email(),
  password: z.string().min(1),
});

export type LoginRequest = z.infer<typeof loginRequestSchema>;

export const loginResponseSchema = z.object({
  token: z.string(),
  user: userPublicSchema,
  expiresAt: z.string().datetime(),
});

export type LoginResponse = z.infer<typeof loginResponseSchema>;

// Registration (public)
export const registerRequestSchema = z.object({
  email: z.string().email(),
  password: z.string().min(8, 'Password must be at least 8 characters'),
  name: z.string().min(1).max(100),
});

export type RegisterRequest = z.infer<typeof registerRequestSchema>;

export const registerResponseSchema = z.object({
  token: z.string(),
  user: userPublicSchema,
  expiresAt: z.string().datetime(),
});

export type RegisterResponse = z.infer<typeof registerResponseSchema>;
